module.exports = __webpack_public_path__ + "static/media/api_buff_logo_1024x512.6463b0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/api_buff_logo_1024x512.png
// module id = 597
// module chunks = 0